// GET_INSURANCE_PLAN
export const GET_INSURANCE_PLAN_REQUEST = 'GET_INSURANCE_PLAN_REQUEST'
export const GET_INSURANCE_PLAN_SUCCESS = 'GET_INSURANCE_PLAN_SUCCESS'
export const GET_INSURANCE_PLAN_FAILURE = 'GET_INSURANCE_PLAN_FAILURE'

// GET_INSURANCE_DEDUCT_PLAN
export const GET_INSURANCE_DEDUCT_PLAN_REQUEST = 'GET_INSURANCE_DEDUCT_PLAN_REQUEST'
export const GET_INSURANCE_DEDUCT_PLAN_SUCCESS = 'GET_INSURANCE_DEDUCT_PLAN_SUCCESS'
export const GET_INSURANCE_DEDUCT_PLAN_FAILURE = 'GET_INSURANCE_DEDUCT_PLAN_FAILURE'

// GENERATE_QUICK_QUOTATION_DOCUMENT
export const GENERATE_QUICK_QUOTATION_DOCUMENT_REQUEST = 'GENERATE_QUICK_QUOTATION_DOCUMENT_REQUEST'
export const GENERATE_QUICK_QUOTATION_DOCUMENT_SUCCESS = 'GENERATE_QUICK_QUOTATION_DOCUMENT_SUCCESS'
export const GENERATE_QUICK_QUOTATION_DOCUMENT_FAILURE = 'GENERATE_QUICK_QUOTATION_DOCUMENT_FAILURE'

// GET_QUOTATION_INFORMATION
export const GET_QUOTATION_INFORMATION_REQUEST = 'GET_QUOTATION_INFORMATION_REQUEST'
export const GET_QUOTATION_INFORMATION_SUCCESS = 'GET_QUOTATION_INFORMATION_SUCCESS'
export const GET_QUOTATION_INFORMATION_FAILURE = 'GET_QUOTATION_INFORMATION_FAILURE'

// UPDATE_QUOTATION_INFORMATION
export const UPDATE_QUOTATION_INFORMATION_REQUEST = 'UPDATE_QUOTATION_INFORMATION_REQUEST'
export const UPDATE_QUOTATION_INFORMATION_SUCCESS = 'UPDATE_QUOTATION_INFORMATION_SUCCESS'
export const UPDATE_QUOTATION_INFORMATION_FAILURE = 'UPDATE_QUOTATION_INFORMATION_FAILURE'

// UPDATE_QUOTATION_COMPLETE_STATUS
export const UPDATE_QUOTATION_COMPLETE_STATUS_REQUEST = 'UPDATE_QUOTATION_COMPLETE_STATUS_REQUEST'
export const UPDATE_QUOTATION_COMPLETE_STATUS_SUCCESS = 'UPDATE_QUOTATION_COMPLETE_STATUS_SUCCESS'
export const UPDATE_QUOTATION_COMPLETE_STATUS_FAILURE = 'UPDATE_QUOTATION_COMPLETE_STATUS_FAILURE'

// GET_CUSTOMER_INQUIRY
export const GET_CUSTOMER_INQUIRY_REQUEST = 'GET_CUSTOMER_INQUIRY_REQUEST'
export const GET_CUSTOMER_INQUIRY_SUCCESS = 'GET_CUSTOMER_INQUIRY_SUCCESS'
export const GET_CUSTOMER_INQUIRY_FAILURE = 'GET_CUSTOMER_INQUIRY_FAILURE'

// CHECK_CUSTOMER_AMLO
export const CHECK_CUSTOMER_AMLO_REQUEST = 'CHECK_CUSTOMER_AMLO_REQUEST'
export const CHECK_CUSTOMER_AMLO_SUCCESS = 'CHECK_CUSTOMER_AMLO_SUCCESS'
export const CHECK_CUSTOMER_AMLO_FAILURE = 'CHECK_CUSTOMER_AMLO_FAILURE'

// CHECK_RISK_TVI
export const CHECK_RISK_TVI_REQUEST = 'CHECK_RISK_TVI_REQUEST'
export const CHECK_RISK_TVI_SUCCESS = 'CHECK_RISK_TVI_SUCCESS'
export const CHECK_RISK_TVI_FAILURE = 'CHECK_RISK_TVI_FAILURE'

// CHECK_RISK_PAYER
export const CHECK_RISK_PAYER_REQUEST = 'CHECK_RISK_PAYER_REQUEST'
export const CHECK_RISK_PAYER_SUCCESS = 'CHECK_RISK_PAYER_SUCCESS'
export const CHECK_RISK_PAYER_FAILURE = 'CHECK_RISK_PAYER_FAILURE'

// SEND_EMAIL_QUOTATION
export const SEND_EMAIL_QUOTATION_REQUEST = 'SEND_EMAIL_QUOTATION_REQUEST'
export const SEND_EMAIL_QUOTATION_SUCCESS = 'SEND_EMAIL_QUOTATION_SUCCESS'
export const SEND_EMAIL_QUOTATION_FAILURE = 'SEND_EMAIL_QUOTATION_FAILURE'

// GET_OCCUPATION_LIST
export const GET_OCCUPATION_LIST_REQUEST = 'GET_OCCUPATION_LIST_REQUEST'
export const GET_OCCUPATION_LIST_SUCCESS = 'GET_OCCUPATION_LIST_SUCCESS'
export const GET_OCCUPATION_LIST_FAILURE = 'GET_OCCUPATION_LIST_FAILURE'

// GET_COUNTRY_INFORMATION
export const GET_COUNTRY_INFORMATION_REQUEST = 'GET_COUNTRY_INFORMATION_REQUEST'
export const GET_COUNTRY_INFORMATION_SUCCESS = 'GET_COUNTRY_INFORMATION_SUCCESS'
export const GET_COUNTRY_INFORMATION_FAILURE = 'GET_COUNTRY_INFORMATION_FAILURE'

// GET_PROVINCE_INFORMATION
export const GET_PROVINCE_INFORMATION_REQUEST = 'GET_PROVINCE_INFORMATION_REQUEST'
export const GET_PROVINCE_INFORMATION_SUCCESS = 'GET_PROVINCE_INFORMATION_SUCCESS'
export const GET_PROVINCE_INFORMATION_FAILURE = 'GET_PROVINCE_INFORMATION_FAILURE'

// GET_DISTRICT_INFORMATION
export const GET_DISTRICT_INFORMATION_REQUEST = 'GET_DISTRICT_INFORMATION_REQUEST'
export const GET_DISTRICT_INFORMATION_SUCCESS = 'GET_DISTRICT_INFORMATION_SUCCESS'
export const GET_DISTRICT_INFORMATION_FAILURE = 'GET_DISTRICT_INFORMATION_FAILURE'

// GET_SUB_DISTRICT_INFORMATION
export const GET_SUB_DISTRICT_INFORMATION_REQUEST = 'GET_SUB_DISTRICT_INFORMATION_REQUEST'
export const GET_SUB_DISTRICT_INFORMATION_SUCCESS = 'GET_SUB_DISTRICT_INFORMATION_SUCCESS'
export const GET_SUB_DISTRICT_INFORMATION_FAILURE = 'GET_SUB_DISTRICT_INFORMATION_FAILURE'

// GET_HOSPITALS_LIST
export const GET_HOSPITALS_LIST_REQUEST = 'GET_HOSPITALS_LIST_REQUEST'
export const GET_HOSPITALS_LIST_SUCCESS = 'GET_HOSPITALS_LIST_SUCCESS'
export const GET_HOSPITALS_LIST_FAILURE = 'GET_HOSPITALS_LIST_FAILURE'

// GET_NAME_PREFIX
export const GET_NAME_PREFIX_REQUEST = 'GET_NAME_PREFIX_REQUEST'
export const GET_NAME_PREFIX_SUCCESS = 'GET_NAME_PREFIX_SUCCESS'
export const GET_NAME_PREFIX_FAILURE = 'GET_NAME_PREFIX_FAILURE'

// GET_REFERRER_INFORMATION
export const GET_REFERRER_INFORMATION_REQUEST = 'GET_REFERRER_INFORMATION_REQUEST'
export const GET_REFERRER_INFORMATION_SUCCESS = 'GET_REFERRER_INFORMATION_SUCCESS'
export const GET_REFERRER_INFORMATION_FAILURE = 'GET_REFERRER_INFORMATION_FAILURE'

// GET_APPLICATION_INFORMATION
export const GET_APPLICATION_INFORMATION_REQUEST = 'GET_APPLICATION_INFORMATION_REQUEST'
export const GET_APPLICATION_INFORMATION_SUCCESS = 'GET_APPLICATION_INFORMATION_SUCCESS'
export const GET_APPLICATION_INFORMATION_FAILURE = 'GET_APPLICATION_INFORMATION_FAILURE'

// GET_CONSENT_INFORMATION
export const GET_CONSENT_INFORMATION_REQUEST = 'GET_CONSENT_INFORMATION_REQUEST'
export const GET_CONSENT_INFORMATION_SUCCESS = 'GET_CONSENT_INFORMATION_SUCCESS'
export const GET_CONSENT_INFORMATION_FAILURE = 'GET_CONSENT_INFORMATION_FAILURE'

// UPDATE_APPLICATION_INFORMATION
export const UPDATE_APPLICATION_INFORMATION_REQUEST = 'UPDATE_APPLICATION_INFORMATION_REQUEST'
export const UPDATE_APPLICATION_INFORMATION_SUCCESS = 'UPDATE_APPLICATION_INFORMATION_SUCCESS'
export const UPDATE_APPLICATION_INFORMATION_FAILURE = 'UPDATE_APPLICATION_INFORMATION_FAILURE'

// UPDATE_PAYER_INFORMATION
export const UPDATE_PAYER_INFORMATION_REQUEST = 'UPDATE_PAYER_INFORMATION_REQUEST'
export const UPDATE_PAYER_INFORMATION_SUCCESS = 'UPDATE_PAYER_INFORMATION_SUCCESS'
export const UPDATE_PAYER_INFORMATION_FAILURE = 'UPDATE_PAYER_INFORMATION_FAILURE'

// UPDATE_MAIN_PAYER
export const UPDATE_MAIN_PAYER_REQUEST = 'UPDATE_MAIN_PAYER_REQUEST'
export const UPDATE_MAIN_PAYER_SUCCESS = 'UPDATE_MAIN_PAYER_SUCCESS'
export const UPDATE_MAIN_PAYER_FAILURE = 'UPDATE_MAIN_PAYER_FAILURE'

// UPDATE_APPLICATION_COMPLETED_STATUS
export const UPDATE_APPLICATION_COMPLETED_STATUS_REQUEST =
  'UPDATE_APPLICATION_COMPLETED_STATUS_REQUEST'
export const UPDATE_APPLICATION_COMPLETED_STATUS_SUCCESS =
  'UPDATE_APPLICATION_COMPLETED_STATUS_SUCCESS'
export const UPDATE_APPLICATION_COMPLETED_STATUS_FAILURE =
  'UPDATE_APPLICATION_COMPLETED_STATUS_FAILURE'

// UPDATE_CONSENT_INSURED_INFORMATION
export const UPDATE_CONSENT_INSURED_INFORMATION_REQUEST =
  'UPDATE_CONSENT_INSURED_INFORMATION_REQUEST'
export const UPDATE_CONSENT_INSURED_INFORMATION_SUCCESS =
  'UPDATE_CONSENT_INSURED_INFORMATION_SUCCESS'
export const UPDATE_CONSENT_INSURED_INFORMATION_FAILURE =
  'UPDATE_CONSENT_INSURED_INFORMATION_FAILURE'

// UPDATE_CONSENT_PAYER_INFORMATION
export const UPDATE_CONSENT_PAYER_INFORMATION_REQUEST = 'UPDATE_CONSENT_PAYER_INFORMATION_REQUEST'
export const UPDATE_CONSENT_PAYER_INFORMATION_SUCCESS = 'UPDATE_CONSENT_PAYER_INFORMATION_SUCCESS'
export const UPDATE_CONSENT_PAYER_INFORMATION_FAILURE = 'UPDATE_CONSENT_PAYER_INFORMATION_FAILURE'

// CREATE_FAMILY_QUOTATION
export const CREATE_FAMILY_QUOTATION_REQUEST = 'CREATE_FAMILY_QUOTATION_REQUEST'
export const CREATE_FAMILY_QUOTATION_SUCCESS = 'CREATE_FAMILY_QUOTATION_SUCCESS'
export const CREATE_FAMILY_QUOTATION_FAILURE = 'CREATE_FAMILY_QUOTATION_FAILURE'

// GET_FAMILY_INFORMATION
export const GET_FAMILY_INFORMATION_REQUEST = 'GET_FAMILY_INFORMATION_REQUEST'
export const GET_FAMILY_INFORMATION_SUCCESS = 'GET_FAMILY_INFORMATION_SUCCESS'
export const GET_FAMILY_INFORMATION_FAILURE = 'GET_FAMILY_INFORMATION_FAILURE'

// GET_FAMILY_PAYER
export const GET_FAMILY_PAYER_REQUEST = 'GET_FAMILY_PAYER_REQUEST'
export const GET_FAMILY_PAYER_SUCCESS = 'GET_FAMILY_PAYER_SUCCESS'
export const GET_FAMILY_PAYER_FAILURE = 'GET_FAMILY_PAYER_FAILURE'

// GET_FAMILY_RELATIONSHIP
export const GET_FAMILY_RELATIONSHIP_REQUEST = 'GET_FAMILY_RELATIONSHIP_REQUEST'
export const GET_FAMILY_RELATIONSHIP_SUCCESS = 'GET_FAMILY_RELATIONSHIP_SUCCESS'
export const GET_FAMILY_RELATIONSHIP_FAILURE = 'GET_FAMILY_RELATIONSHIP_FAILURE'

// GET_BENEFICIARY_RELATIONSHIP
export const GET_BENEFICIARY_RELATIONSHIP_REQUEST = 'GET_BENEFICIARY_RELATIONSHIP_REQUEST'
export const GET_BENEFICIARY_RELATIONSHIP_SUCCESS = 'GET_BENEFICIARY_RELATIONSHIP_SUCCESS'
export const GET_BENEFICIARY_RELATIONSHIP_FAILURE = 'GET_BENEFICIARY_RELATIONSHIP_FAILURE'

// UPDATE_FAMILY_RELATIONSHIP
export const UPDATE_FAMILY_RELATIONSHIP_REQUEST = 'UPDATE_FAMILY_RELATIONSHIP_REQUEST'
export const UPDATE_FAMILY_RELATIONSHIP_SUCCESS = 'UPDATE_FAMILY_RELATIONSHIP_SUCCESS'
export const UPDATE_FAMILY_RELATIONSHIP_FAILURE = 'UPDATE_FAMILY_RELATIONSHIP_FAILURE'

// GET_PAYMENT_INFORMATION
export const GET_PAYMENT_INFORMATION_REQUEST = 'GET_PAYMENT_INFORMATION_REQUEST'
export const GET_PAYMENT_INFORMATION_SUCCESS = 'GET_PAYMENT_INFORMATION_SUCCESS'
export const GET_PAYMENT_INFORMATION_FAILURE = 'GET_PAYMENT_INFORMATION_FAILURE'

// GET_TMB_ACCOUNT_INFORMATION
export const GET_TMB_ACCOUNT_INFORMATION_REQUEST = 'GET_TMB_ACCOUNT_INFORMATION_REQUEST'
export const GET_TMB_ACCOUNT_INFORMATION_SUCCESS = 'GET_TMB_ACCOUNT_INFORMATION_SUCCESS'
export const GET_TMB_ACCOUNT_INFORMATION_FAILURE = 'GET_TMB_ACCOUNT_INFORMATION_FAILURE'

// SEND_OTP_VERIFICATION
export const SEND_OTP_VERIFICATION_REQUEST = 'SEND_OTP_VERIFICATION_REQUEST'
export const SEND_OTP_VERIFICATION_SUCCESS = 'SEND_OTP_VERIFICATION_SUCCESS'
export const SEND_OTP_VERIFICATION_FAILURE = 'SEND_OTP_VERIFICATION_FAILURE'

// VERIFY_OTP_VERIFICATION
export const VERIFY_OTP_VERIFICATION_REQUEST = 'VERIFY_OTP_VERIFICATION_REQUEST'
export const VERIFY_OTP_VERIFICATION_SUCCESS = 'VERIFY_OTP_VERIFICATION_SUCCESS'
export const VERIFY_OTP_VERIFICATION_FAILURE = 'VERIFY_OTP_VERIFICATION_FAILURE'

// PAY_VIA_BILL_PAYMENT
export const PAY_VIA_BILL_PAYMENT_REQUEST = 'PAY_VIA_BILL_PAYMENT_REQUEST'
export const PAY_VIA_BILL_PAYMENT_SUCCESS = 'PAY_VIA_BILL_PAYMENT_SUCCESS'
export const PAY_VIA_BILL_PAYMENT_FAILURE = 'PAY_VIA_BILL_PAYMENT_FAILURE'

// PAY_VIA_CREDIT_CARD
export const PAY_VIA_CREDIT_CARD_REQUEST = 'PAY_VIA_CREDIT_CARD_REQUEST'
export const PAY_VIA_CREDIT_CARD_SUCCESS = 'PAY_VIA_CREDIT_CARD_SUCCESS'
export const PAY_VIA_CREDIT_CARD_FAILURE = 'PAY_VIA_CREDIT_CARD_FAILURE'

// PAY_VIA_QR_CODE
export const PAY_VIA_QR_CODE_REQUEST = 'PAY_VIA_QR_CODE_REQUEST'
export const PAY_VIA_QR_CODE_SUCCESS = 'PAY_VIA_QR_CODE_SUCCESS'
export const PAY_VIA_QR_CODE_FAILURE = 'PAY_VIA_QR_CODE_FAILURE'

// QR_VERIFY_SLIP
export const QR_VERIFY_SLIP_REQUEST = 'QR_VERIFY_SLIP_REQUEST'
export const QR_VERIFY_SLIP_SUCCESS = 'QR_VERIFY_SLIP_SUCCESS'
export const QR_VERIFY_SLIP_FAILURE = 'QR_VERIFY_SLIP_FAILURE'

// WEB_SOCKET_CONNECTION
export const WEB_SOCKET_ONOPEN = 'WEB_SOCKET_ONOPEN'
export const WEB_SOCKET_ONCLOSE = 'WEB_SOCKET_ONCLOSE'
export const WEB_SOCKET_ONERROR = 'WEB_SOCKET_ONERROR'
export const WEB_SOCKET_ONMESSAGE = 'WEB_SOCKET_ONMESSAGE'
export const WEB_SOCKET_RECONNECT = 'WEB_SOCKET_RECONNECT'
export const WEB_SOCKET_RECONNECT_ERROR = 'WEB_SOCKET_RECONNECT_ERROR'
